import type { WidgetBootstrapResponse } from '../types/PublicBookingChannelTypes'
import type { JobType } from './jobTypes'
import { toBasketItem, type BasketItem } from './services'

/**
 * The basket after the customer picks `service` inside its category (ACA-100).
 *
 * Options in one category are alternatives: Interim or Full Service, a test or
 * a retest. Picking one takes the place of whatever else from that category is
 * already in the basket, at the same position so the basket does not reshuffle.
 * Picking the one already chosen takes it back out. Other categories are left
 * alone, so an MOT and a service still book together.
 */
export function chooseInCategory(
  basket: BasketItem[],
  jobType: JobType,
  service: WidgetBootstrapResponse.ServiceItem
): BasketItem[] {
  if (basket.some((item) => item.serviceId === service.id)) {
    return basket.filter((item) => item.serviceId !== service.id)
  }

  const inCategory = new Set(jobType.services.map((entry) => entry.id))
  const firstSibling = basket.findIndex((item) => inCategory.has(item.serviceId))
  const chosen = toBasketItem(service)

  if (firstSibling === -1) return [...basket, chosen]

  return basket.flatMap((item, index) => {
    if (index === firstSibling) return [chosen]
    return inCategory.has(item.serviceId) ? [] : [item]
  })
}
